var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLineBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M0.955002 6.84484L4.675 9.78984C4.405 10.0798 4.2 10.4348 4.09 10.8298L0.225006 7.76984C0.0800061 7.65484 0 7.48484 0 7.30484C0 6.95484 0.290001 6.71484 0.595001 6.71484C0.715001 6.71484 0.845002 6.75484 0.955002 6.84484Z",
    fill: "#D0D7DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M13.03 6.33984C13.1 6.75984 13.3 7.13484 13.59 7.41984L8.935 10.9298C8.84 10.5248 8.645 10.1548 8.375 9.84984L13.03 6.33984Z",
    fill: "#D0D7DE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bright-fill",
    d: "M19.9999 9.19996V9.22996C19.9999 9.71496 19.4449 9.98996 19.0549 9.69996L16.2349 7.57496C16.5549 7.32496 16.7899 6.97996 16.9149 6.58496L19.7649 8.72996C19.9149 8.84496 19.9999 9.01496 19.9999 9.19996Z",
    fill: "#D0D7DE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M8.2498 20.1998H3.2498C2.8648 20.1998 2.5498 19.8848 2.5498 19.4998C2.5498 19.1148 2.8648 18.7998 3.2498 18.7998H8.2498C8.6348 18.7998 8.9498 19.1148 8.9498 19.4998C8.9498 19.8848 8.6348 20.1998 8.2498 20.1998Z",
    fill: "#AFB8C1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M10.2498 17.4498H3.2498C2.8648 17.4498 2.5498 17.1348 2.5498 16.7498C2.5498 16.3648 2.8648 16.0498 3.2498 16.0498H10.2498C10.6348 16.0498 10.9498 16.3648 10.9498 16.7498C10.9498 17.1348 10.6348 17.4498 10.2498 17.4498Z",
    fill: "#AFB8C1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M9 11.5C9 12.88 7.88 14 6.5 14C5.12 14 4 12.88 4 11.5C4 11.27 4.03 11.045 4.09 10.83C4.2 10.435 4.405 10.08 4.675 9.79C5.135 9.305 5.78 9 6.5 9C7.22 9 7.92 9.33 8.375 9.85C8.645 10.155 8.84 10.525 8.935 10.93C8.975 11.115 9 11.305 9 11.5Z",
    fill: "#AFB8C1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "deep-fill",
    d: "M16.9999 6C16.9999 6.205 16.9699 6.4 16.9149 6.585C16.7899 6.98 16.5549 7.325 16.2349 7.575C15.8949 7.84 15.4649 8 15.0049 8C14.4549 8 13.9599 7.775 13.5949 7.42C13.3049 7.135 13.1049 6.76 13.0349 6.34C13.0149 6.23 13.0049 6.115 13.0049 6C13.0049 4.895 13.8999 4 15.0049 4C16.1099 4 17.0049 4.895 17.0049 6H16.9999Z",
    fill: "#AFB8C1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineBottom);
export default __webpack_public_path__ + "static/media/line-bottom.882e8e64d7d029ed2c8a01f101481dbf.svg";
export { ForwardRef as ReactComponent };